/* eslint-disable @typescript-eslint/no-var-requires */
const React = require('react')
const { useAuth0 } = require('@auth0/auth0-react')
const { useLocation } = require('@reach/router')
const { CoachMarkPresenter } = require('./dist/cjs/index.js')

/**
 * Gatsby wrapper around the shared presenter. Kept as CJS so the
 * Next.js library build never compiles @reach/router. Gatsby apps
 * already provide Auth0 and Reach Router at runtime.
 */
const CoachMarkGatsbyRoot = () => {
  const location = useLocation()
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()

  return React.createElement(CoachMarkPresenter, {
    pathname: location.pathname,
    isAuthenticated,
    isAuthLoading: isLoading,
    loginWithRedirect,
  })
}

module.exports = CoachMarkGatsbyRoot
